import React, { useEffect, useState } from 'react';

import CustomAutoExpandingTextarea from '../../../components/Inputs/AutoExpandingTextarea/AutoExpandingTextarea';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { ButtonContainer, Header } from './styles';
import { cropConnectApiClient } from '../../../../services/cropConnectApiClient';
import { useContextStore } from '../../../../stores/storeRoot';
import ActionButton from '../../../components/ActionButton/ActionButton';
import Loader from '../../../components/Loader/Loader';
import { useI18n } from '../../../../hooks/useI18n';
import { decodeHtml, encodeHtml } from '../../../../helpers/encodingHelper';

const ServiceProviderSettings = () => {
  const { activeBpNumber } = useContextStore();
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialValue, setInitialValue] = useState('');
  const [hasBeenEdited, setHasBeenEdited] = useState(false);
  const [additionalData, setAdditionalData] = useState('');
  const [saveSuccessMessage, setSaveSuccessMessage] = useState('');
  const { t } = useI18n();

  useEffect(() => {
    if (activeBpNumber) {
      setIsLoading(true);
      cropConnectApiClient
        .getDeliveryPlanProviderInfo(activeBpNumber)
        .then((r) => {
          if (r.success) {
            setIsEnabled(true);
            const initialValue = decodeHtml(r.data?.additionalInfo ?? '');
            setAdditionalData(initialValue);
            setInitialValue(initialValue);
          }
        })
        .catch((e) => {
          console.error(e);
          setIsEnabled(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [activeBpNumber]);

  return (
    <>
      <Header>
        {t(TranslationKeys.serviceprovider_deliveryplan_administration_header)}
      </Header>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <CustomAutoExpandingTextarea
            value={additionalData}
            onChange={(e) => {
              setAdditionalData(e.target.value);
              setHasBeenEdited(true);
            }}
            placeholder={
              t(
                TranslationKeys.serviceprovider_additional_info_placeholder
              ) as string
            }
            label={
              t(
                TranslationKeys.serviceprovider_additional_info_placeholder
              ) as string
            }
            disabled={!isEnabled}
          />
          <ButtonContainer>
            <ActionButton
              variant="ghost"
              buttonText={t(TranslationKeys.cancel_button)}
              onClickAction={() => {
                setAdditionalData(initialValue);
                setHasBeenEdited(false);
              }}
              disabled={!hasBeenEdited}
            />
            <ActionButton
              variant="accept-blue"
              buttonText={t(TranslationKeys.save_button)}
              onClickAction={() => {
                if (activeBpNumber) {
                  cropConnectApiClient
                    .createOrUpdateServiceProviderAdditionalInfo(
                      activeBpNumber,
                      {
                        additionalData: encodeHtml(additionalData),
                      }
                    )
                    .then((r) => {
                      if (r.success) {
                        setSaveSuccessMessage(
                          t(
                            TranslationKeys.delivery_plan_saved_message
                          ) as string
                        );
                        setHasBeenEdited(false);
                      }
                    });
                }
              }}
              disabled={!hasBeenEdited}
            />
          </ButtonContainer>
          {saveSuccessMessage && (
            <div style={{ color: 'green', marginTop: '10px' }}>
              {saveSuccessMessage}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ServiceProviderSettings;
